var exports = {
  "vU": "App.module__appContainer___OVpfTW",
  "lq": "App.module__overlayScope___OVpfTW",
  "u$": "App.module__skipLink___OVpfTW",
  "pq": "App.module__quickSwitcherPortal___OVpfTW",
};

module.exports = exports;
